/*
 *  Bootstrap Nice Select Polish (Poland) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['pl-PL'] = localisation.locales['pl'] = {
    formatSearch() {
        return "Badawczy...";
    },
    formatHelpForTagging() {
        return "Aby utworzyć własne tagi, zaznacz pole wprowadzania, a następnie naciśnij 'Enter' lub ',' lub 'Spacja', aby dodać je do listy";
    }
}

export default localisation;